import styled, { css } from 'styled-components';

const shouldForwardProp = prop => prop !== 'selectedTab';

const selectedTabStyled = selectedTab => {
  if (selectedTab) {
    return css`
      color: var(--Primary-500);
      border-bottom: 2px solid var(--Primary-500);
    `;
  }
};

export const TabStyled = styled.div.withConfig({ shouldForwardProp })`
  padding: 15px 0px;
  display: inline-flex;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  padding: 9px 0px;
  width: 50%;
  justify-content: center;

  ${props => selectedTabStyled(props.selectedTab)}
`;
